import type { Event, EventPayload, RunRecord } from '@orgsim/shared';

export type ChannelMessage =
  | { kind: 'event'; event: Event } // main -> map: applied event
  | { kind: 'propose'; payload: EventPayload } // map -> main: please dispatch
  | { kind: 'undo' } // map -> main
  | { kind: 'requestSync' } // map -> main
  | { kind: 'sync'; run: RunRecord } // main -> map: full state, reduced by examineeRecord
  | { kind: 'closed' }; // main -> map: main window is gone

export function openChannel(runId: string): BroadcastChannel {
  return new BroadcastChannel(`orgsim-run-${runId}`);
}

export function post(channel: BroadcastChannel, message: ChannelMessage): void {
  channel.postMessage(message);
}
